import { render, staticRenderFns } from "./rules.vue?vue&type=template&id=88c663ae"
import script from "./rules.ts?vue&type=script&lang=js&external"
export * from "./rules.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports